import CookieBanner from "./CookieBanner";

export { getCookieConsentValue } from "react-cookie-consent";
export default CookieBanner;
